import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCar2Ev: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="car-2-ev"><path d="M19.75 17.25H22.25V10L17 8.75L14 4.75H7L1.75 10V17.25H4.25" stroke="currentColor" strokeWidth="1.5"/><path d="M9.75 17.25H14.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="7" cy="16.75" r="2.5" stroke="currentColor" strokeWidth="1.5"/><circle cx="17" cy="16.75" r="2.5" stroke="currentColor" strokeWidth="1.5"/><path d="M14.5 10H11.9167L12.3334 7L8.5 12H11.0833L10.6667 15L14.5 10Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCar2Ev;
